import { visaOptionsByCountry } from 'wisestep-base';

export const updateWorkAuthorizationCategory = (data) => {
  const selectedCountry = data?.workAuthorization;
  if (selectedCountry) {
    const countryOptions = visaOptionsByCountry.find(
      (entry) => entry.country.toUpperCase() === selectedCountry.toUpperCase()
    );
    if (countryOptions) {
      const selectedVisaOption = countryOptions.options.find(
        (option) => option.value === data?.visaStatus
      );
      return selectedVisaOption ? selectedVisaOption.additionalInfo : '';
    }
  }
  return '';
};
